import * as React from "react";
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";

export type GridSidebarTab = "search" | "pdfViewer" | "comparison" | "columnAnalysis" | "review";

interface Props {
  tab: GridSidebarTab;
  setTab: (tab: GridSidebarTab) => void;
  initialTab: GridSidebarTab;
  showReviewTab?: boolean;
}

export const GridSidebarTabs: React.FC<Props> = ({ tab, setTab, initialTab, showReviewTab = false }) => (
  <div className="flex gap-2 pl-4">
    <Button variant={tab === "search" ? "secondary" : "ghost"} size="sm" onClick={() => setTab("search")}>
      <Sparkles className="mr-2 h-5 w-5" />
      AI Search
    </Button>
    {initialTab !== "search" && (
      <>
        <Button variant={tab === "pdfViewer" ? "secondary" : "ghost"} size="sm" onClick={() => setTab("pdfViewer")}>
          Source
        </Button>
        <Button variant={tab === "comparison" ? "secondary" : "ghost"} size="sm" onClick={() => setTab("comparison")}>
          Comparison
        </Button>
        {showReviewTab && (
          <Button variant={tab === "review" ? "secondary" : "ghost"} size="sm" onClick={() => setTab("review")}>
            Review
          </Button>
        )}
      </>
    )}
  </div>
);
